import {Attachment} from '../Attachment';
import {Type} from 'class-transformer';

export class LoginCustomization {

  public text: string;
  @Type(() => Attachment)
  public logos: Array<Attachment> = [];
}
